import { MAGNET_VISUAL_PRESETS } from './magnetVisualDesign.js';

// Jobs and their starter looks travel together through the catalog, editor and
// runtime. Appearance remains editable independently of the question contract.
const step = (id, type, prompt, field, label, options = [], config = {}, answerId) => ({
  id, step_type:type, step_prompts:[prompt], step_columns:[field],
  step_options:options.map(label => ({label,goto:''})), step_description:'', step_config:config,
  step_answer:{version:1,label,label_mode:'custom',...(answerId ? {id:answerId} : {})},
});
const additional = id => `additional_${id.replaceAll('-','')}`;
function appearance(style, mode, welcome, title, subtitle, cta, success) {
  const preset = MAGNET_VISUAL_PRESETS.find(item => item.visual_style === style);
  return {
    title,subtitle,display_mode:'chat',trigger:'none',presentation_style:'assistant',
    launcher_style:'invitation',launcher_label:cta,launcher_hint:subtitle,visitor_controls:true,
    theme_mode:mode,theme_color:preset.brand,font:preset.font,theme_vars:{...preset[mode],...(style === 'aurora' ? {surface:'#191c32',surface_2:'#2d2d49',msg_bg:'#191c32',bot_bg:'#2d2d49',border:'#68627f',bot_border:'#68627f',text:'#f5f1ff',text_sub:'#c7c2db',meta:'#c7c2db'} : {})},
    visual_style:style,message_style:'soft',motion_style:style === 'paper' ? 'float' : 'fade',
    home:welcome.layout !== 'direct',actions:[{type:'chat',label:cta,value:''}],
    welcome_experience:{...welcome,primary_action:'chat',primary_label:cta,answers:[]},
    summary:true,summary_heading:'Review your request',summary_confirm_label:cta,
    success_title:'Request sent',success_text:success,
  };
}
const contact = heading => [
  step('name','text','Your name','name','Name',[],{group_heading:heading}),
  step('email','email','Email address','email','Email',[],{group_with_previous:true}),
];
const environmentId = '873baf61-07c9-4b50-8931-3a585d53f69e';
const quoteTimingId = '12c4380e-b671-4c5b-a12f-57be8bb94d76';

export const ISSUE_REPORT_TEMPLATE = {
  id:'issue_report',name:'Issue report',category:'support',icon:'bug_report',
  description:'Collect what went wrong, how to reproduce it, and where to reply. A focused alternative to a general help desk.',
  tags:['Problem details','Support requests'],featured:false,marketing_excluded:true,
  appearance:appearance('signal','light',{layout:'direct',heading:'',intro:''},
    'Report an issue','Help us understand what happened','Send issue report',
    'Your report has been received. The team can follow up using the email you shared.'),
  steps:[
    step('area','single_select','Where are you running into trouble?','product_interest','Affected area',
      ['Signing in','Using a feature','Something else']),
    step('details','text','What happened, and what did you expect instead?','description','Issue details'),
    step('environment','text','Which device or browser were you using?',additional(environmentId),'Device or browser',[],
      {optional:true,skip_label:'Not sure'},environmentId),
    ...contact('Where can we reply?'),
  ],
};
export const GUIDED_QUOTE_TEMPLATE = {
  id:'guided_quote',name:'Guided quote',category:'lead_capture',icon:'request_quote',
  description:'Turn a project idea into a useful quote request with scope, timing and contact details. Your team prepares the estimate.',
  tags:['Project scope','Quote requests'],featured:false,
  appearance:appearance('paper','light',{layout:'spotlight',heading:'Tell us what you have in mind.',
    intro:'Share a few details. Our team will review your project and follow up.'},
    'Your project starts here','A few details. A useful next step.','Request a quote',
    'Your project request has been received. The team will review it before preparing a quote or asking for more details.'),
  steps:[
    step('project','single_select','What kind of project are you planning?','product_interest','Project type',
      ['A new project','An upgrade or renovation','Help defining the scope']),
    step('scope','text','What would you like us to work on?','description','Project scope'),
    step('timing','single_select','When would you like to get started?',additional(quoteTimingId),'Preferred timing',
      ['As soon as practical','In the next few months','Just exploring'],{},quoteTimingId),
    ...contact('Where should we send the next steps?'),
  ],
};
export const SERVICE_CONSULTATION_TEMPLATE = {
  id:'service_consultation',name:'Product & service consultation',category:'lead_capture',icon:'forum',
  description:'Help visitors explain what they are exploring and the outcome they want before your team follows up.',
  tags:['Expert guidance','Consultation requests'],featured:false,
  appearance:appearance('aurora','dark',{layout:'concierge',heading:'Find your next move.',
    intro:'Tell us what you are exploring. We will help you work out the next step.'},
    'Let’s work it out','A conversation about what comes next','Request a consultation',
    'Your consultation request has been received. The team can follow up to discuss your needs and arrange a time.'),
  steps:[
    step('interest','single_select','What would you like to explore?','product_interest','Consultation topic',
      ['Choosing the right product','Planning a service project','Not sure where to start']),
    step('goal','text','What would a good outcome look like for you?','description','Desired outcome'),
    step('company','text','Company or organization','company','Company',[],{optional:true,skip_label:'Skip this'}),
    ...contact('Let’s keep the conversation going'),
  ],
};
export const SERVICE_STARTER_TEMPLATES = [ISSUE_REPORT_TEMPLATE,GUIDED_QUOTE_TEMPLATE,SERVICE_CONSULTATION_TEMPLATE];
